const WHT = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="512"
    height="512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(996,24)"
      d="m0 0h57l40 2 37 3 47 6 40 7 41 9 32 8 43 13 35 12 31 12 26 11 26 12 21 10 19 10 24 13 24 14 19 12 25 16 18 13 14 10 16 12 28 22 30 26 10 9 13 12 10 10 2 1v2l4 2 8 8 7 8 13 13 7 8 12 13 9 11 13 15 22 28 12 16 24 34 21 33 9 15 16 28 12 23 10 19 13 28 14 32 14 37 8 22 13 42 11 42 8 36 7 38 6 43 4 41 2 33v90l-2 33-3 33-6 44-7 40-9 41-10 38-11 36-12 35-16 41-13 29-14 29-14 28-13 23-14 24-14 22-18 27-13 18-10 14-22 28-9 11-12 14-9 10-7 8-9 10-8 8-7 8-24 24h-2l-1 3-8 7-8 8-8 7-14 12-10 9-14 11-15 12-17 13-17 12-14 10-15 10-17 11-21 13-23 13-18 10-33 17-36 17-29 12-37 14-36 12-34 10-44 11-38 8-51 8-34 4-40 3-19 1h-84l-45-3-46-5-38-6-37-7-42-10-36-10-52-17-31-12-31-13-28-13-44-22-24-14-18-10-44-28-18-13-17-12-18-14-15-12-11-9-14-12-10-9-11-9-11-11-8-7-35-35-7-8-7-7-9-11-11-12-9-11-13-16-11-14-15-20-13-19-10-14-14-22-13-21-16-28-13-24-19-38-15-34-13-33-9-24-12-37-11-39-8-32-9-45-7-45-4-36-3-39-1-23v-69l2-38 3-34 6-46 7-40 8-37 8-32 10-34 12-37 12-32 12-29 16-35 8-17 20-38 14-24 10-17 11-17 18-27 13-18 10-14 12-15 7-9 11-14 10-11 9-11 11-12 7-8 13-13 7-8 18-18 8-7 13-13 8-7 13-11 15-13 16-13 16-12 17-13 20-14 13-9 25-16 19-12 23-13 18-10 33-17 30-14 25-11 31-12 30-11 38-12 45-12 41-9 32-6 42-6 27-3 42-3z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1259,368)"
      d="m0 0h10l6 4 3 5 1 44 1 226 10-3 25-11 36-15 77-33 12-3 8 4 3 4 2 9 1 10v37l-3 21-5 20-8 22-11 21-12 17-11 13-15 15-14 11-14 10-15 9-23 12-21 9-21 7-1 1v52l9-3 26-11 42-18 68-29 11-4 8 1 6 5 2 5 2 16v36l-3 22-5 20-7 19-8 17-12 19-11 13-11 12-12 11-13 10-18 12-17 10-23 11-24 9-11 3 1 53 9-3 30-13 110-47 7-2h6l6 4 3 4 2 9 1 10v36l-3 22-5 20-8 21-8 16-8 13-9 12-12 14-15 14-17 13-15 10-25 14-20 9-20 7-9 3-1 53 14-5 51-22 52-22 35-15 3-1h9l5 3 3 4 3 19v37l-3 21-5 20-8 22-12 23-12 17-11 12-1 2h-2l-2 4-8 7-12 10-15 11-20 12-15 8-28 12-20 7-1 119-4 7-6 4h-10l-7-5-2-7-1-117-12-5-21-8-29-14-21-13-16-12-13-11-17-17-10-13-10-16-10-19-8-22-5-23-2-16v-38l2-14 3-6 5-4 2-1h7l28 11 30 13 26 11 47 20 25 11-1-53-35-14-16-7-22-12-19-13-16-13-7-7-8-7-9-11-10-13-9-15-8-16-6-16-4-14-4-21-1-10v-38l2-14 3-6 5-4 2-1 9 1 25 10 26 11 28 12 45 19 23 10 7 3-1-53-19-7-24-10-20-10-18-11-18-13-10-9-8-7-8-8-9-11-11-15-12-22-8-20-5-19-3-17-1-10v-37l2-15 3-6 8-5 8 1 34 14 115 49 5 2-1-53-22-8-21-9-16-8-13-7-18-12-16-13-8-7-12-12-11-14-9-13-9-16-9-21-5-17-4-22-1-9v-39l2-14 4-7 5-3h9l32 13 108 46 15 6v-271l3-5z"
      fill="#FDFEFE"
    />
    <path
      transform="translate(759,504)"
      d="m0 0h10l5 3 4 5 1 30 1 165 1 46 31-13 47-20 30-13 24-10 4-1h7l6 4 3 4 2 8 1 15v23l-3 23-6 23-6 15-8 16-10 15-9 11-9 10-12 11-16 12-19 12-21 11-28 11-9 3v44l47-20 26-11 56-24 8-3h7l6 4 3 5 2 7 1 14v24l-2 17-4 19-8 24-11 21-12 17-12 13-12 12-20 15-20 12-15 8-27 11-12 4-1 1v43l13-5 96-41 24-10 3-1h8l5 3 3 3 3 10 1 12v25l-3 24-6 23-6 15-8 16-10 15-11 13-8 9-8 7-13 11-20 13-22 12-24 10-15 5h-2v45l28-12 31-13 21-9 32-14 19-8 7-2 8 1 5 4 3 6 1 5 1 14v25l-3 22-4 17-8 22-10 19-12 17-14 15-8 8-14 11-21 14-27 14-35 14-1 105-3 6-6 5h-11l-7-6-2-6-1-104-28-11-22-10-17-10-17-12-13-11-10-9-13-15-11-16-11-21-7-19-4-17-2-15-1-13v-15l2-21 3-7 6-5 7-1 16 6 31 13 80 34 12 5v-44l-10-3-25-10-16-8-13-7-18-12-16-13-18-18-12-16-9-15-8-17-5-15-4-17-2-14-1-15v-12l1-16 3-13 6-5 2-1h8l25 10 87 37 18 8 7 3-1-44-21-8-25-11-21-12-12-8-16-13-8-7-7-7-9-11-11-15-10-18-8-21-5-20-2-15-1-13v-16l2-20 3-8 6-4 7-1 21 8 94 40 24 10-1-43-41-17-17-9-16-10-12-9-10-8-18-18-13-17-10-17-7-15-5-15-4-17-2-14-1-14v-14l2-21 3-8 5-4 2-1h7l24 9 44 19 45 19 25 11v-240l3-6z"
      fill="#FDFEFE"
    />
    <path
      transform="translate(1421,620)"
      d="m0 0h4v19l-2 18-5 22-6 16-10 19-8 12-11 14-16 16-17 13-19 12-16 8-21 9-11 4h-3l-1-75v-45l2-3 29-12 35-15 26-11 35-15z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1422,1097)"
      d="m0 0h3v20l-3 24-4 15-6 17-9 17-8 12-10 13-5 6h-2l-2 4-12 11-16 12-15 9-23 12-20 8-10 3-1-82v-38l1-3 31-13 40-17 26-11 30-13z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1421,1336)"
      d="m0 0h4v19l-2 19-4 18-6 17-8 16-10 16-11 14-8 9-8 7-12 10-18 12-18 10-23 10-13 5h-4l-1-80v-39l1-3 28-12 40-17 26-11 28-12z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1421,859)"
      d="m0 0h4v19l-3 24-5 19-8 19-10 18-9 12-13 15-8 8-14 11-13 9-17 10-19 9-24 9h-2l-1-77v-44l4-3 24-10 47-20 59-25z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1104,619)"
      d="m0 0 13 5 29 12 58 25 33 14 11 5 1 30v90l-1 2-5-1-22-9-21-10-18-11-13-10-11-9-10-10-7-8-6-8-10-15-9-19-6-18-4-20-2-16z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1104,858)"
      d="m0 0 9 3 31 13 56 24 45 19 3 2 1 38v83l-3 1-29-12-20-10-19-12-16-13-6-5-7-8-10-11-8-11-9-15-9-21-5-18-3-19-1-9z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1104,1336)"
      d="m0 0 6 1 56 24 26 11 56 24 1 30-1 92-6-1-26-11-16-8-12-7-12-8-11-9-10-9-11-11-12-16-9-15-8-17-5-15-4-20-2-17z"
      fill="#DCAE06"
    />
    <path
      transform="translate(1104,1097)"
      d="m0 0 5 1 31 13 84 36 22 9 2 2 1 39v81l-1 2-6-2-27-11-23-12-12-8-17-13-14-14-9-10-9-12-11-19-8-20-5-21-3-22z"
      fill="#DCAE06"
    />
    <path
      transform="translate(904,733)"
      d="m0 0h3v12l-3 24-5 19-7 16-10 17-11 14-11 12-13 11-21 14-17 9-25 10h-4l-1-73v-30l1-3 78-33 35-15z"
      fill="#DCAE06"
    />
    <path
      transform="translate(902,947)"
      d="m0 0h5v11l-2 19-5 21-6 15-8 15-11 16-14 15-12 11-16 11-21 12-19 8-10 4h-3l-1-73v-32l14-7 26-11 45-19 28-12z"
      fill="#DCAE06"
    />
    <path
      transform="translate(905,1373)"
      d="m0 0h2v13l-3 24-6 21-10 21-11 16-9 11-13 13-13 10-19 12-25 12-15 6h-3l-1-74v-30l2-3 26-11 43-18 37-16z"
      fill="#DCAE06"
    />
    <path
      transform="translate(904,1160)"
      d="m0 0h3v12l-3 25-5 17-5 13-10 18-10 13-12 14-10 9-15 11-15 9-25 12-13 5h-4l-1-73v-30l1-3 31-13 47-20 38-16z"
      fill="#DCAE06"
    />
    <path
      transform="translate(623,1373)"
      d="m0 0 9 3 24 10 91 39 1 1 1 8v97l-4 1-24-11-16-8-17-11-13-10-19-19-8-11-8-13-8-17-5-17-4-25z"
      fill="#DCAE06"
    />
    <path
      transform="translate(623,1160)"
      d="m0 0 6 1 84 36 26 11 9 4 1 9v97l-6-1-26-11-18-10-20-14-15-14-9-10-8-11-8-13-7-16-5-17-3-16-1-9z"
      fill="#DCAE06"
    />
    <path
      transform="translate(623,946)"
      d="m0 0 14 5 103 44 8 4 1 8v97l-2 1-22-9-16-8-11-6-14-10-10-8-11-10-9-11-8-11-9-16-6-14-5-19-3-20z"
      fill="#DCAE06"
    />
    <path
      transform="translate(623,733)"
      d="m0 0 5 1 38 16 63 27 19 8 1 9v97l-6-1-21-9-16-8-15-9-13-10-15-14-12-14-9-14-8-16-4-10-5-22-2-15-1-15z"
      fill="#DCAE06"
    />
  </svg>
);
export default WHT;
